import { http } from "bm-ui-kit";
import type { WorkerLoanDetails, WorkerLoanRequest, WorkerLoanResponse } from "./types";

export function renderText(eligibleForWorkerLoan: boolean): WorkerLoanDetails {
	if (eligibleForWorkerLoan) {
		return {
			eligible: "jogosult lehetsz",
			details:
				"Megtudhatod a hitellel kapcsolatos információkat. Iratkozz fel és elküldjük a kölcsönről megjelenő újdonságokat!",
			alternativeSolution: "Érdemes megnézned milyen alternatív megoldások lehetnek!",
			compareOffers: "Hasonlítsd össze az egyes személyi hitel ajánlatokat!",
		};
	}

	return {
		eligible: "nem vagy jogosult",
		details:
			"Megtudhatod a részletes leírásból, hogy milyen feltételeket kell teljesítened a kölcsön elnyeréséhez.",
		alternativeSolution: "Nem kell lemondanod a célodról azért, mert nem kaphatsz munkáshitelt!",
		compareOffers: "Néd meg milyen feltételekkel igényelhetszszemélyi hitelt!",
	};
}

export async function evaluateEligibilityForLoan(request: WorkerLoanRequest): Promise<boolean> {
	return http
		.post(`${window.APP_CONFIG.BM_API_URL}/api/public/workerloan/v1/calculate`, request)
		.then((response: WorkerLoanResponse) => {
			return !response?.legalKOs?.length && response?.results.some((result) => !result.bankKOs?.length);
		});
}
